import Big from 'big.js';
import _ from 'lodash';
import { DateTime } from 'luxon';

import { FieldReadFunction } from '@apollo/client';



export function dateTimeFieldPolicy() {
  const read: FieldReadFunction = (existing: unknown) => {
    if (existing === null) {
      return existing;
    }

    if (existing === undefined) {
      return existing;
    }

    if (_.isString(existing)) {
      return DateTime.fromISO(existing);
    }

    if (_.isObject(existing)) {
      const asDt = existing as DateTime;

      try {
        asDt.day.toFixed(2);
        return asDt;
      } catch (err) {
        debugger;
        // This is not a date time object.
        throw err;
      }
    }

    debugger;
    throw new Error('Error parsing value to DateTime');
  };

  return {
    read
  };
}



export function currencyAndDecimalFieldPolicy() {
  const read: FieldReadFunction = (existing: unknown) => {
    if (existing === null) {
      return null;
    }

    if (existing === undefined) {
      return undefined;
    }

    if (_.isNumber(existing) || (_.isString(existing) && !_.isNaN(+existing))) {
      return Big(existing);
    }

    if (_.isObject(existing) && !_.isNaN(+existing.toString())) {
      return Big(existing as Big);
    }

    debugger;
    throw new Error('Error converting currency or decimal field');
  };

  return {
    read
  };
}
